import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img1 from "../../images/solution/wearable/spending.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {Link} from 'gatsby';

const spending = () => {
  return (
    <div className="spending p-100" style={{ backgroundColor: "#F6F6F6" }}>
        <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5} >
                        <h2>Wearable App Spending Will Double Next Year – Invest In It To Earn Significant Profits</h2>
                        <p>Wearable app spending will grow to $63 billion in 2021, registering double digit growth from just $32.5 billion in 2018. The market grew twice in size in just three years, making it perhaps one of the most lucrative avenues to invest in the field of app development.</p>
                        <p>Tekrevol’s wearable app development services can be your perfect partner towards this goal.</p>
                        <p>Incorporating the latest in Android wearable technology and custom wearable device app services, our team can build just about any type of wearable app for you.</p>
                        <Link to="/contact"
                                  className="border_btn" aria-label="TekRevol Contact"> Contact Today For A Free Consultation</Link>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-xl-1">
                    <LazyLoadImage
                            src={Img1}
                            effect="blur" alt="TekRevol" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default spending